import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const stagesRoute: RouteConfig = {
  path: 'stages',
  name: 'stageList',
  component: () => import(/* webpackChunkName: "Stage" */ '@/views/mainRoute/stage/List.vue'),
  beforeEnter: (to, from, next) => {
    Promise.all([store.dispatch('stage/list'), store.dispatch('module/list')])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.STAGE_CANNOT_LIST }));
  }
};
